let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/user/user'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click .disable-user': 'disable'
    })
  },
  list () {
    if (this.session.user.profil=='admin') {
      let data = $('#form-pagination').serialize()
      this.hideFormEvent()

      $('#user-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

      app.ajax({
        url: '/user',
        data,
        success: (...args) => this.refreshList(...args)
      })
    } else {

    }
  },
  refreshList (users, status, xhr) {
    $('#user-list').html(require('views/templates/user/list')({
      users,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.initList()
  },
  update (e) {
  },
  showFormEvent (data) {
  },
  hideFormEvent (e) {
  },
  prepareFormEvent (e) {
  },
  processFormEvent (e) {
  },
  delete (e) {
    if (e) e.preventDefault()
  },
  disable (e) {
    if (e) e.preventDefault()
  }

})
